import React from "react";
import styles from "./Achievements.module.css";

const Achievements = () => {
  const achievements = [
    {
      title: "Web Development and Programming",
      issuer: "FiTech Academy",
      year: "2022",
    },
    {
      title: "The Web Developer Bootcamp",
      issuer: "Colt Steele",
      year: "2022",
    },
    {
      title: "React - The Complete Guide",
      issuer: "Academind · Maximilian Schwarzmüller",
      year: "2023",
    },
    {
      title: "React Native - The Practical Guide",
      issuer: "Academind · Maximilian Schwarzmüller",
      year: "2026",
    },
  ];

  return (
    <>
      <div className={styles.divider}></div>
      <section id="achievements" className={styles.achievements}>
        <div className={styles.container}>
          <span className={`${styles.label} mono`}>03 /</span>
          <h2 className={styles.title}>Achievements</h2>

          <div className={styles.grid}>
            {achievements.map((achievement, index) => (
              <div key={index} className={styles.card}>
                <h3 className={styles.cardTitle}>{achievement.title}</h3>
                <p className={styles.issuer}>{achievement.issuer}</p>
                <div className={`${styles.year} mono`}>{achievement.year}</div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default Achievements;
